// @ts-check
// @see https://docs.stoqapp.com/javascript-api#openmodal
if (!customElements.get('bis-button')) {
  class BISButton extends HTMLElement {
    constructor() {
      super();
      this.button = null;
      this.productData = undefined;
      this.variantId = undefined;
      this.customerData = undefined;
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;

      this.variantId = this.getAttribute('data-variant-id');

      try {
        this.productData = JSON.parse(this.getAttribute('data-product-data'));
      } catch (err) {
        // No product data attribute, or invalid JSON
      }

      this.button.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(event) {
      if (!this.button.hasAttribute('data-bis-active')) {
        return; // Let normal add-to-cart proceed
      }

      event.preventDefault();

      if (!window._RestockRocket) {
        // App not available on this page - fallback to product link if in card context
        const cardWrapper = this.closest('.card-wrapper');
        if (cardWrapper) {
          const productLink = cardWrapper.querySelector('a[href]');
          if (productLink) {
            window.location.href = productLink.href;
            return;
          }
        }
        console.error('window._RestockRocket not available. Is Stoq app installed?');
        return;
      }

      const formEl = this.closest('form');
      const appBtn = formEl?.querySelector('.restock-rocket-button-cover, .restock-rocket-button.restock-rocket-button-collection');

      if (appBtn) {
        appBtn.click();
      } else {
        console.log('productData', this.productData);
        console.log('variantId', this.variantId);
        console.log('customerData', this.customerData);

        window._RestockRocket.openModal(this.productData, this.variantId, this.customerData);
      }
    }
  }

  customElements.define('bis-button', BISButton);
}
